module.exports = __webpack_public_path__ + "img/logo_sh_login@2x.7fa8ccc1.png";